import { render, staticRenderFns } from "./PhoneNumberComponent.vue?vue&type=template&id=ffc898e8"
import script from "./PhoneNumberComponent.vue?vue&type=script&lang=js"
export * from "./PhoneNumberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports